/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { GROUND_MOTION_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';
import { countryIsUS } from '#support/models/localeHelpers/index.js';

type Props = {|
  form: string,
  country: string,
  name: string,
|};

const getItems = country => {
  const sp3Name = countryIsUS(country)
    ? 'U.S. Geological Survey'
    : 'Approximate International Hazard';
  const items = [
    { id: GROUND_MOTION_METHOD_VALUES.USGS, name: sp3Name },
    { id: GROUND_MOTION_METHOD_VALUES.UPLOAD, name: 'User Defined Upload' },
  ];
  return items.map(({ id, name }) => ({
    id,
    name,
    value: id,
  }));
};

const GroundMotionMethodSelectMenu = ({
  country,
  form,
  name,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={getItems(country)}
    id={name}
    name={name}
    includeEmptyOption={false}
  />
);

export default GroundMotionMethodSelectMenu;
